
<div class="news-page flex flex-row">
  <div class="news-page-item-container">
    <cs-placeholder [rows]="isLoadingDebounced$ | async" [width]="'50%'" [isLoading]="false"></cs-placeholder>
    <pmc-news-list #newsListComponent [newsItems]="newsItems"></pmc-news-list>
  </div>
</div>

